/**
 * @file card-visibility.service.ts
 * `IntersectionObserver` unique et partagé pour toutes les `app-card` de
 * l'application (racine — `providedIn: 'root'`), au lieu d'une instance par
 * carte. Une grille de 150+ cartes (inventaire, marketplace) créait autant
 * d'observers ; ici un seul observer surveille tous les éléments enregistrés
 * et redistribue chaque changement au callback correspondant.
 */

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CardVisibilityService {
  private observer: IntersectionObserver | null = null;
  private readonly callbacks = new Map<Element, (visible: boolean) => void>();

  /** Enregistre `el` : `cb` est appelé avec `true`/`false` à chaque changement d'intersection viewport. */
  observe(el: Element, cb: (visible: boolean) => void): void {
    this.observer ??= new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          this.callbacks.get(entry.target)?.(entry.isIntersecting);
        }
      },
      { rootMargin: '200px' }, // démarre un peu avant l'entrée réelle pour éviter un "pop"
    );
    this.callbacks.set(el, cb);
    this.observer.observe(el);
  }

  /** À appeler dans `ngOnDestroy` du composant hôte. */
  unobserve(el: Element): void {
    this.observer?.unobserve(el);
    this.callbacks.delete(el);
  }
}
